/****************
 * THE SPEED RUN'S BACKTEST, WATCHED APP-WIDE (11-01). The run's result step
 * waits for RUN_SIGNAL.backtestDone; My Copies sends it only while open, so a
 * watcher mounted once (web MainLayout, phone app/_layout) polls that one
 * backtest every 10 s wherever the person is, and sends it once.
 * Byte-identical twin in frontend/src/lib and mobile-app/src/lib.
 ****************/

export const BACKTEST_WATCH_MS = 10_000;

/** Watch only during a run, with a backtest started in it, and the signal not yet seen. */
export function shouldWatchBacktest(inRun: boolean, backtestId: string | undefined, seen: string[], signal: string): boolean {
  return inRun && !!backtestId && !seen.includes(signal);
}

/** A backtest that will never finish (failed, stopped for time, cancelled): the run goes back to its backtest step. */
export function backtestFailed(status: string | null | undefined): boolean {
  const s = (status || '').toLowerCase();
  return s === 'failed' || s === 'error' || s === 'cancelled' || s === 'canceled';
}

/** The server's word for a finished backtest ('done'; 'finished'/'completed' read the same). */
export function backtestFinished(status: string | null | undefined): boolean {
  const s = (status || '').toLowerCase();
  return s === 'done' || s === 'finished' || s === 'completed';
}
